import { BaseModel } from "@/models/base.model"
import { LockRepository } from "@/repositories/lock-repository"
import { useLockStore } from "@/store/lock-store"

export class LockController {
  private lockStore = useLockStore()

  public async lockRemote(model: BaseModel) {
    if (!model.id) {
      throw Error("Cannot lock a model that is not saved.")
    }

    const response = await new LockRepository().lock(model.getClassName(), model.id)
    const lockAcquired = response.status === 201 // Will return 423: Locked if the lock is already held by someone else.
    if (lockAcquired) {
      this.lockStore.lockModelLocal(model)
    }
    return lockAcquired
  }

  public async releaseRemote(model: BaseModel) {
    if (!model.id) {
      return // E.g. when the model is not saved yet.
    }

    // TODO I switched order of below lines to prevent dual release http-call. If any issues arise, revert this change.
    this.lockStore.releaseModelLocal(model)
    await new LockRepository().release(model.getClassName(), model.id)
  }
}
